import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import PuliziePage from './pages/PuliziePage';
import LavanderiaPage from './pages/LavanderiaPage';
import BiancheriaPage from './pages/BiancheriaPage';
import TovagliatoPage from './pages/TovagliatoPage';
import AdminPage from './pages/AdminPage';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="pulizie" element={<PuliziePage />} />
            <Route path="lavanderia" element={<LavanderiaPage />} />
            <Route path="biancheria" element={<BiancheriaPage />} />
            <Route path="tovagliato" element={<TovagliatoPage />} />
            <Route path="admin" element={<AdminPage />} />
          </Route>
        </Routes>
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
